<template>
  <div class="wrapper">
    <side-bar>
      <mobile-menu slot="content"></mobile-menu>
      <sidebar-link
      v-if="isRoleVisible(['ADMIN', 'MANAGER', 'FINANCE', 'USER'])"
      :class="checkSelected('Dashboard')"
      to="/dashboard/overview"
    >
      <i><b-icon icon="pie-chart-fill" aria-hidden="true"></b-icon></i>
      <p>{{ translate('dashboard') }}</p>
    </sidebar-link>

    <!-- Sidebar Link for Super Admin, Super Manager, Super Finance, and Super User roles -->
    <sidebar-link
      v-if="isRoleVisible(['SUPER_ADMIN', 'SUPER_MANAGER', 'SUPER_FINANCE', 'SUPER_USER'])"
      :class="checkSelected('DashboardSuper')"
      to="/dashboard/overview/super"
    >
      <i><b-icon icon="pie-chart-fill" aria-hidden="true"></b-icon></i>
      <p>{{ translate('dashboard') }}</p>
    </sidebar-link>
      <!-- <sidebar-link v-if="menus.includes('User')" to="/dashboard/user"> -->
      <sidebar-link  :class="checkSelected('user')" v-if="menus.includes('User')" to="/dashboard/user">
        <i>
        <b-icon icon="people" aria-hidden="true"></b-icon></i>
        <p>{{ translate('users') }}</p>
      </sidebar-link>
      <sidebar-link  :class="checkSelected('UserSuper')" v-if="menus.includes('User_Super')" to="/dashboard/user/super">
        <i>
        <b-icon icon="people" aria-hidden="true"></b-icon></i>
        <p>{{ translate('users') }}</p>
      </sidebar-link>
      <sidebar-link  :class="checkSelected('UserSystem')" v-if="menus.includes('User_System')" to="/dashboard/user/system">
        <i>
        <b-icon icon="people" aria-hidden="true"></b-icon></i>
        <p>{{ translate('users') }}</p>
      </sidebar-link>
      <sidebar-link :class="checkSelected('Association')" v-if="menus.includes('Association')" to="/dashboard/association/types">
        <i>
        <b-icon icon="tags" aria-hidden="true"></b-icon></i>
        <p>{{ translate('association') }}</p>
      </sidebar-link>
      <sidebar-link :class="checkSelected('Association_Super')" v-if="menus.includes('Association_Super')" to="/dashboard/association/types/super">
        <i>
        <b-icon icon="tags" aria-hidden="true"></b-icon></i>
        <p>{{ translate('association') }}</p>
      </sidebar-link>
      <sidebar-link :class="checkSelected('Members')"  v-if="menus.includes('Members')" to="/dashboard/members">
        <i>
        <b-icon icon="person-fill" aria-hidden="true"></b-icon></i>
        <p>{{ translate('members') }}</p>
      </sidebar-link>
      <sidebar-link :class="checkSelected('Members_Super')"  v-if="menus.includes('Members_Super')" to="/dashboard/members/super">
        <i>
        <b-icon icon="person-fill" aria-hidden="true"></b-icon></i>
        <p>{{ translate('members') }}</p>
      </sidebar-link>
      <sidebar-link :class="checkSelected('Association_Linkage')"  v-if="menus.includes('Association_Linkage')" to="/dashboard/association/links">
        <i>
        <b-icon icon="link" aria-hidden="true"></b-icon></i>
        <p>{{ translate('associationLinkage') }}</p>
      </sidebar-link>
      <sidebar-link :class="checkSelected('Association_Linkage_Super')"  v-if="menus.includes('Association_Linkage_Super')" to="/dashboard/association/links/super">
        <i>
        <b-icon icon="link" aria-hidden="true"></b-icon></i>
        <p>{{ translate('associationLinkage') }}</p>
      </sidebar-link>
      <sidebar-link :class="checkSelected('ekub draw')" v-if="menus.includes('Ekub Draw')" to="/dashboard/ekub/draw">
        <i>
        <b-icon icon="gift" aria-hidden="true"></b-icon></i>
        <p>{{ translate('drawingChance') }}</p>
      </sidebar-link>
      <sidebar-link :class="checkSelected('Drawing_Chance')" v-if="menus.includes('Drawing_Chance')" to="/dashboard/draw/chance/super">
        <i>
        <b-icon icon="gift" aria-hidden="true"></b-icon></i>
        <p>{{ translate('drawingChance') }}</p>
      </sidebar-link>
      <sidebar-link :class="checkSelected('payments')"  v-if="menus.includes('Payment')"  to="/dashboard/payments">
        <i>
        <b-icon icon="cash-coin" aria-hidden="true"></b-icon></i>
        <p>{{ translate('paymentsHistory') }}</p>
      </sidebar-link>
      <sidebar-link :class="checkSelected('Payment_Super')"  v-if="menus.includes('Payment_Super')"  to="/dashboard/payments/super">
        <i>
        <b-icon icon="cash-coin" aria-hidden="true"></b-icon></i>
        <p>{{ translate('paymentsHistory') }}</p>
      </sidebar-link>
       <sidebar-link :class="checkSelected('report')"  v-if="menus.includes('Report')"  to="/dashboard/report">
        <i>
        <b-icon icon="bar-chart-steps" aria-hidden="true"></b-icon></i>
        <p>{{ translate('report') }}</p>
      </sidebar-link>
      <sidebar-link :class="checkSelected('Report_Super')"  v-if="menus.includes('Report_Super')"  to="/dashboard/report/super">
        <i>
        <b-icon icon="bar-chart-steps" aria-hidden="true"></b-icon></i>
        <p>{{ translate('report') }}</p>
      </sidebar-link>
      <sidebar-link :class="checkSelected('AuditLogs_Super')" v-if="menus.includes('AuditLogs_Super')" to="/dashboard/audit-logs/super">
        <i>
        <b-icon icon="journal-text" aria-hidden="true"></b-icon></i>
        <p>{{ translate('auditLogs') }}</p>
      </sidebar-link>
      <sidebar-link :class="checkSelected('ManualPaymentUpdate')"  v-if="menus.includes('Manual_Payment_Update')"  to="/dashboard/manual-payment-update">
        <i>
        <b-icon icon="credit-card" aria-hidden="true"></b-icon></i>
        <p>Manual Payment Update</p>
      </sidebar-link>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import MobileMenu from './MobileMenu.vue'
  import { translate, setLanguage } from 'src/i18n.js';  // Importing the translation functions
  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      MobileMenu
    },
    data () {
      return {
        menus: [],
        userRole: sessionStorage.getItem("user_role")
      }
    },
    mounted() {
      this.getMenus();
    },
    computed: {
      currentRouterName(){
        return this.$route.name;
      }
    },
    mounted() {
      this.getMenus();
      // Set the language based on localStorage or fallback to default (English)
      const storedLang = localStorage.getItem('preferredLanguage') || 'en';
      this.changeLanguage(storedLang);
    },
    methods: {
      translate,
    changeLanguage(lang) {
    this.$i18n.locale = lang; // Use Vue I18n to change language
    localStorage.setItem('preferredLanguage', lang); // Optionally store the language preference
    this.$forceUpdate(); // Forces a re-render
    },
    checkSelected(path) {
    // Compare with route name instead of path
    if (this.$route.name && this.$route.name.toLowerCase() === path.toLowerCase()) {
      return "selected";
    }
    return "";
  },
    // Check if the user's role matches any of the provided roles
    isRoleVisible(allowedRoles) {
      return allowedRoles.includes(this.userRole);
    },
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },
      getMenus(){
        var some = sessionStorage.getItem('modules');
        if(some !== "" || some !== null){
          this.menus = some.split(",");
        }else{
          this.$router.push('/');
        }
      }
    }
  }

</script>
<style>
.selected > a{
    background: rgba(255, 255, 255, 0.13);
    opacity: 1;
}
.lang{
    color:#fff !important;
    background: rgba(255, 255, 255, 0.13) !important;
  }
</style>